module.exports = __webpack_public_path__ + "img/promotion_06.jpg";